import { render, staticRenderFns } from "./StartConversation.vue?vue&type=template&id=56b53a74"
import script from "./StartConversation.vue?vue&type=script&lang=js"
export * from "./StartConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports